import { useState, useEffect } from 'react'

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState({
    hh: '00',
    mm: '00',
    ss: '00',
  })

  useEffect(() => {
    const key = 'co_timer_expiry'
    let expiry = localStorage.getItem(key)

    if (!expiry || Date.now() > parseInt(expiry)) {
      expiry = (Date.now() + 24 * 60 * 60 * 1000).toString() // 24 hours
      localStorage.setItem(key, expiry)
    }

    const expiryTime = parseInt(expiry)

    const updateTimer = () => {
      const diff = Math.max(0, expiryTime - Date.now())
      const hh = Math.floor(diff / 3600000)
      const mm = Math.floor((diff % 3600000) / 60000)
      const ss = Math.floor((diff % 60000) / 1000)

      const pad = (n: number) => String(n).padStart(2, '0')

      setTimeLeft({
        hh: pad(hh),
        mm: pad(mm),
        ss: pad(ss),
      })
    }

    updateTimer()
    const interval = setInterval(updateTimer, 1000)

    return () => clearInterval(interval)
  }, [])

  return timeLeft
}
